import { render, staticRenderFns } from "./BordereauCard.vue?vue&type=template&id=400f1842&scoped=true&"
import script from "./BordereauCard.vue?vue&type=script&lang=js&"
export * from "./BordereauCard.vue?vue&type=script&lang=js&"
import style0 from "./BordereauCard.vue?vue&type=style&index=0&id=400f1842&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400f1842",
  null
  
)

export default component.exports